import request from './request'

// 获取大咖列表数据
export function getDkList(page, pagesize, isstar, keyword) {
  const url = '/teacher/teacherlist'
  let params = {
    page: page,
    pagesize: pagesize,
    isstar: isstar
  }
  if (typeof keyword !== 'undefined') {
    params.keywords = keyword
  }
  return request.get(url, {
    params: params
  })
}

// 大咖的详情页面
export function getDkDetail(id) {
  const url = '/user_profile/profile'
  return request.get(url, {
    params: {
      id: id
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/daka.js